export enum AffinityQueryKeys {
  GET_AFFINITY_MEMBER = 'GET_AFFINITY_MEMBER',
}
